import { Route, Routes } from "react-router-dom";
import Home from "../pages/Home/Home";
import Error from "../components/Error/Error404";
import UserManagement from "../pages/Admin/User-Master/user-management";
import NonStandardMLFb from "../pages/Admin/Non-Standard-MLFB/non-standard-mlfb";
import ZCodeMaster from "../pages/Admin/Z-Code-Master/z-code-master";
import StandardMLFB from "../pages/Admin/Standard-MLFB/standard-mlfb";
import StandardMLFBBulkUpload from "../pages/Admin/Std-MLFB-Bulk-Upload/std-mlfb-bulk";
import PriceList from "../pages/Sales/price_list";
import Quotation from "../pages/Sales/quotation";
import UploadDrawing from "../pages/Designer/uploadDrawing";
import UnauthorizedAccess from "../pages/UnauthorizedAccess/UnauthorizedAccess";

export const AdminRoute = (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route exact path="/User" element={<UserManagement />} />
    <Route exact path="/NonStandardMLFB" element={<NonStandardMLFb />} />
    <Route exact path="/ZCodeMaster" element={<ZCodeMaster />} />
    <Route exact path="/StandardMLFB" element={<StandardMLFB />} />
    <Route exact path="/StandardMLFBBulkUpload" element={<StandardMLFBBulkUpload />} />
    <Route exact path="/PriceList" element={<PriceList />} />
    <Route exact path="/UploadDrawing" element={<UploadDrawing />} />
    <Route exact path="/Quotation" element={<Quotation />} />
    <Route path="/UnAuthorised" element={<UnauthorizedAccess />} />
    <Route from="/signin-oidc*" to="/" />
    <Route path="*" element={<Error />}></Route>
  </Routes>
);

export const SalesRoute = (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route exact path="/PriceList" element={<PriceList />} />
    <Route exact path="/Quotation" element={<Quotation />} />
    <Route exact path="/StandardMLFB" element={<StandardMLFB />} />
    <Route from="/signin-oidc*" to="/" />
    <Route path="*" element={<Error />}></Route>
  </Routes>
);

export const DesignerRoute = (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route exact path="/UploadDrawing" element={<UploadDrawing />} />
    <Route from="/signin-oidc*" to="/" />
    <Route path="*" element={<Error />}></Route>
  </Routes>
);

export const Saleslist = (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route exact path="/PriceList" element={<PriceList />} />
    <Route from="/signin-oidc*" to="/" />
    <Route path="*" element={<Error />}></Route>
  </Routes>
);